import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { LogoutComponent } from './logout.component';

@NgModule({
  declarations: [LogoutComponent],
  imports: [CommonModule, MatIconModule],
  exports: [LogoutComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LogoutModule {}
